import { apiCall } from '../../utils/APIFunctions';
import KPConfig from '../../KPConfig';

export function fetchSignupTemplates(locale) {
  return apiCall(`${KPConfig.backendUrl}/start/templates/${locale}`, "GET");
}

export function createAccount(params) {
  const currentURL = window.location.search;

  const urlParams = new URLSearchParams(currentURL);
  const utmSource = urlParams.get('utm_source');
  const utmMedium = urlParams.get('utm_medium');
  const utmCampaign = urlParams.get('utm_campaign');
  const utmTerm = urlParams.get('utm_term');
  const utmContent = urlParams.get('utm_content');

  const updatedParams = {
    ...params,
    utm_source: utmSource,
    utm_medium: utmMedium,
    utm_campaign: utmCampaign,
    utm_term: utmTerm,
    utm_content: utmContent
  };

  return apiCall(`${KPConfig.backendUrl}/quick-trial`, "POST", JSON.stringify(updatedParams));
}

export async function getLoginConfig() {
  return apiCall(`${KPConfig.newBackendUrl}/api/n1/login/config`, "GET");
}

export function login(params) {
  return apiCall(`${KPConfig.backendUrl}/clientlogin`, "POST", JSON.stringify(params));
}

export async function loginWithASSO(params) {
  return apiCall(
    `${KPConfig.newBackendUrl}/api/n1/asso/login`,
    "POST",
    JSON.stringify(params),
    null,
    {skipErrorHandling: true}
  );
}

export function oldBeTokenLogin(params) {
  return apiCall(
    `${KPConfig.backendUrl}/api/v2/token-login`,
    "POST",
    JSON.stringify(params),
    null,
    {skipErrorHandling: true}
  );
}

export function newBeLogin(params) {
  return apiCall(
    `${KPConfig.newBackendUrl}/api/n1/tokenLogin`,
    "POST",
    JSON.stringify(params),
    null,
    {skipErrorHandling: true}
  );
}

export function newBeLogout(params) {
  return apiCall(
    `${KPConfig.newBackendUrl}/api/n1/logout`,
    "POST",
    JSON.stringify(params),
    null,
    {skipErrorHandling: true}
  );
}

export function sendPasswordReset(params) {
  return apiCall(`${KPConfig.backendUrl}/password-reset`, "POST", JSON.stringify(params));
}

export function sendEmailVerificationEmail(email) {
  return apiCall(`${KPConfig.backendUrl}/start/sendEmailVerificationEmail`, "POST", JSON.stringify({email: email}));
}

export function sendLoginEmail(email) {
  return apiCall(`${KPConfig.backendUrl}/sendLoginEmail`, "POST", JSON.stringify({email: email}));
}

export function inviteLogin(params) {
  return apiCall(`${KPConfig.backendUrl}/inviteLogin?id=${params.inviteId}&invite=${params.invite}&objectId=${params.objectId}`, "GET");
}

export function validatePasswordResetCode(code) {
  return apiCall(`${KPConfig.backendUrl}/passwordResetCode?code=${code}`, "GET");
}
export function passwordReset(params) {
  return apiCall(`${KPConfig.backendUrl}/passwordReset`, "POST", JSON.stringify(params));
}

export function getNonce() {
  return apiCall(`${KPConfig.backendUrl}/api/v2/login-nonce`, "GET");
}

export function respondToChallenge(params) {
  return apiCall(`${KPConfig.backendUrl}/api/v2/login-challenge`, "POST", JSON.stringify(params));
}

export function getObjectDownloadTokenStatus(params) {
  return apiCall(`${KPConfig.backendUrl}/objectDownloadTokenStatus?id=${params.id}&token=${params.token}`, "GET");
}

export function openTrial(trialType) {
  let url = `${KPConfig.backendUrl}/trial`;
  if (trialType) {
    url += `/${trialType}`;
  }
  return apiCall(url, "POST");
}
